import { render } from "./ResetSuccess.vue?vue&type=template&id=0dbc3f06"
import script from "./ResetSuccess.vue?vue&type=script&lang=js"
export * from "./ResetSuccess.vue?vue&type=script&lang=js"

import "./ResetSuccess.vue?vue&type=style&index=0&id=0dbc3f06&lang=css"

import exportComponent from "C:\\WORK\\Tamani\\admin-landing\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__